import { WEEKLY_SCHEDULE_STORAGE_MAX_LENGTH, emptyDeliveryPlanning, weeklyScheduleSchema, } from '../schemas/delivery-planning.js';
import { formatDeliveryPlanning } from './delivery-planning.js';
/** Retain the existing custom-field string contract while validating its structured contents. */
export function parseWeeklySchedule(value) {
    if (typeof value !== 'string' || value.length > WEEKLY_SCHEDULE_STORAGE_MAX_LENGTH)
        return null;
    let decoded;
    try {
        decoded = JSON.parse(value);
    }
    catch {
        return null;
    }
    const result = weeklyScheduleSchema.safeParse(decoded);
    return result.success ? result.data : null;
}
export function serializeWeeklySchedule(value) {
    const groups = new Map();
    for (const window of weeklyScheduleSchema.parse(value)) {
        const key = `${window.from}-${window.until}`;
        const previous = groups.get(key);
        groups.set(key, {
            ...window,
            weekdays: [...(previous?.weekdays ?? []), ...window.weekdays].sort((left, right) => left - right),
        });
    }
    const windows = [...groups.values()];
    windows.sort((left, right) => Math.min(...left.weekdays) - Math.min(...right.weekdays) ||
        left.from.localeCompare(right.from) ||
        left.until.localeCompare(right.until) ||
        left.weekdays.join(',').localeCompare(right.weekdays.join(',')));
    return JSON.stringify(windows);
}
export function formatWeeklySchedule(value, language) {
    return formatDeliveryPlanning({
        ...emptyDeliveryPlanning(),
        enabled: true,
        receivingWindows: value,
    }, language).receiving;
}
//# sourceMappingURL=weekly-schedule.js.map